import * as React from "react";
import { Splash } from "Views/scaffolding/pages/splash";
import { RoutesHOC } from "Views/scaffolding/routes";

/** Properties needed to render the root of the component tree. */
export type RootProps = {
  /** Initializes the application. */
  initialize(): void;
  /** The overall status of the application. */
  status: "INITIALIZING" | "LOADING" | "READY";
};

/** Renders the root component for the view layer. */
function Root(props: RootProps): JSX.Element {
  const { initialize, status } = props;

  React.useEffect(() => {
    initialize();
  }, []);

  return (
    <React.Fragment>
      {status === "READY" ? <RoutesHOC /> : <Splash />}
    </React.Fragment>
  );
}

const rootMemo = React.memo<RootProps>(Root);
export { rootMemo as Root };
